<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">发票列表</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">发票列表</div>
        <div class="z-display-inlineBlock z-margin-left-10-precent"><xbutton font="索取发票" type="confirm" @XbuttonService="gotInvoice"/></div>
      </div>
      <div class="panel-body clearfix">
        <div class="Z-hr"></div>
        <div class="block">
          <span class="demonstration">起止时间：</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
          &nbsp;&nbsp;&nbsp;
          <div class="z-display-inlineBlock">
            <xbutton type="search" font="查询" class="z-border-all-grey" @XbuttonService="SearchInvoice"/>
          </div>
        </div>
        <!--列表-->
        <el-table :data="userList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="invoice_money" label="发票金额" align="center">
          </el-table-column>
          <el-table-column prop="addtime" label="申请时间" align="center">
          </el-table-column>
          <el-table-column prop="income_head" label="发票抬头" align="center">
          </el-table-column>
          <el-table-column prop="invoice_content" label="发票内容" min-width="120" align="center">
          </el-table-column>
          <el-table-column prop="charge_type" label="收取方式" align="center">
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center">
          </el-table-column>
          <el-table-column prop="shuihao" label="纳税人识别号" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="" label="操作" align="center">
            <template slot-scope="scope">
              <span class="z-curPonit z-color-a" @click="Details(scope.$index, scope.row)">详情</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>

      </div>
    </div>
    <!--详情界面-->
    <el-dialog
      title="发票快递详情"
      :visible.sync="showDetails"
      width="30%">
      <div class="detail-body">
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">开具类型：</span>
          <span>{{details.income_head}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">发票号码：</span>
          <span>{{details.invoice_id}}</span>

        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">发票内容：</span>
          <span>{{details.invoice_content}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">快递公司：</span>
          <span>{{details.kd_info.split('|')[0]}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">快递单号：</span>
          <span>{{details.kd_info.split('|')[1]}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">收件人：</span>
          <span>{{details.linkmana}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">收件地址：</span>
          <span>{{details.adderss}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">联系电话：</span>
          <span>{{details.tel}}</span>
        </p>
        <p class="z-lineHeight-25">
          <span class="z-display-inlineBlock z-font-weight-700">开票金额：</span>
          <span class="z-color-red">{{details.invoice_money}}</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
            <span class="z-display-inlineBlock"><xbutton font="确 定" type="confirm" @XbuttonService="showDetails = false"></xbutton></span>
            </span>
    </el-dialog>
  </div>
</template>
<script>
  import Xtable from 'components/commons/Xtable.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import caiwuService from 'business/caiwuService.js'
  export default {
    data() {
      return {
        userList: [],
        listLoading:false,
        count: 10,
        total: 0,
        page:1,
        date: [],
        showDetails:false,
        details:{
          kd_info:'',
          invoice_id:'',
          income_head:'',
          kd_hao:'',
          invoice_content:'',
          kuaidi:'',
          linkmana:'',
          adderss:'',
          tel:'',
          invoice_money:''
        }
      }
    },
    components:{
      Xtable,
      Xbutton,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchInvoice()
    },
    methods:{
      gotInvoice() {
        this.$router.push('./caiwu3')
      },
      async SearchInvoice() {
        this.listLoading = true
        let date0 = this.date[0] ? this.date[0] : ''
        let date1 = this.date[1] ? this.date[1] : ''
        let data = 'cmd=invoice_list'+'&count='+ this.count +'&page='+ this.page +'&caiwu_time_1='+date0+'&caiwu_time_2='+date1
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.data.allcount
          this.userList = vueData.data.content.map((item, index) => {
            return {
              invoice_money:'￥'+item.invoice_money,
              addtime:item.addtime,
              income_head:item.taitou,
              invoice_content:item.invoice_content,
              charge_type:item.charge_type,
              state:item.state,
              shuihao:item.shuihao,
              kd_hao:item.kd_hao,
              kuaidi:item.kuaidi,
              linkmana:item.linkmana,
              adderss:item.adderss,
              tel:item.tel,
              kd_info:item.kd_info,
              invoice_id:item.invoice_id
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchInvoice()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchInvoice()
      },
      Details(index, row) {
        this.showDetails = true;
        this.details = Object.assign({}, row);
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .detail-body span {
    font-size: 13px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/caiwu/caiwu4.vue